module.exports = __webpack_public_path__ + "media/mypage/images/bglogin-7a578a5d8d5d2dfb6c95f67b8c3c8d14.jpg";